import { render, staticRenderFns } from "./claimNotice.vue?vue&type=template&id=062a8afb&scoped=true&"
import script from "./claimNotice.vue?vue&type=script&lang=js&"
export * from "./claimNotice.vue?vue&type=script&lang=js&"
import style0 from "./claimNotice.vue?vue&type=style&index=0&id=062a8afb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "062a8afb",
  null
  
)

export default component.exports